import * as actions from "./actions";
import { rootRef, storageRef } from "../../config/firebase";
import forOwn from "lodash/forOwn";
import moment from "moment";

function obtenerPreinscripcionesPorColegio() {
  return dispatch => {
    rootRef
      .child("escuelas/verano2018/preinscripciones")
      .once("value", snap => {
        const preins = snap.val();
        let prom = [];
        let numpre = {};

        forOwn(preins, (pres, idColegio) => {
          const numpres = Object.keys(pres).length;
          prom.push(
            rootRef.child(`detalles/colegios/${idColegio}`).once("value")
          );
          numpre = Object.assign({}, numpre, {
            [idColegio]: numpres
          });
        });

        Promise.all(prom)
          .then(resp => {
            let payload = [];
            resp.forEach(r =>
              payload.push(
                Object.assign({}, r.val(), {
                  num: numpre[r.key],
                  id: r.key
                })
              )
            );
            dispatch(actions.obtenerPreinscripcionesPorColegio(payload));
          })
          .catch(error => console.log(error));
      });
  };
}

function limpiarPreinscripcionesPorColegio() {
  return actions.limpiarPreinscripcionesPorColegio();
}

function obtenerPreinscripcionesDelColegio(idColegio) {
  return dispatch => {
    dispatch(onAddedPreinscripcionesDelColegio(idColegio));
    dispatch(onChangedPreinscripcionesDelColegio(idColegio));
    dispatch(onRemovedPreinscripcionesDelColegio(idColegio));
  };
}

function onAddedPreinscripcionesDelColegio(idColegio) {
  return dispatch => {
    rootRef
      .child(`escuelas/verano2018/preinscripciones/${idColegio}`)
      .on("child_added", snap => {
        dispatch(
          actions.onAddedPreinscripcionesDelColegio({
            ...snap.val(),
            idInscripcion: snap.key
          })
        );
      });
  };
}

function onChangedPreinscripcionesDelColegio(idColegio) {
  return dispatch => {
    rootRef
      .child(`escuelas/verano2018/preinscripciones/${idColegio}`)
      .on("child_changed", snap => {
        dispatch(
          actions.onChangedPreinscripcionesDelColegio({
            ...snap.val(),
            idInscripcion: snap.key
          })
        );
      });
  };
}

function onRemovedPreinscripcionesDelColegio(idColegio) {
  return dispatch => {
    rootRef
      .child(`escuelas/verano2018/preinscripciones/${idColegio}`)
      .on("child_removed", snap => {
        dispatch(
          actions.onRemovedPreinscripcionesDelColegio({
            ...snap.val(),
            idInscripcion: snap.key
          })
        );
      });
  };
}

function detachPreinscripcionesDelColegio(idColegio) {
  return dispatch =>
    rootRef.child(`escuelas/verano2018/preinscripciones/${idColegio}`).off();
}

function limpiarPreinscripcionesDelColegio() {
  return actions.limpiarPreinscripcionesDelColegio();
}

function obtenerDatosColegio(idColegio) {
  let prom = [
    rootRef.child(`detalles/colegios/${idColegio}`).once("value"),
    rootRef.child(`escuelas/verano2018/precios/${idColegio}`).once("value")
  ];

  return dispatch =>
    Promise.all(prom)
      .then(resp => {
        const id = resp[0].key;
        let payload = resp[0].val();
        payload.idColegio = id;

        payload.precios = resp[1].val();

        dispatch(actions.obtenerDatosColegio(payload));
      })
      .catch(error => error);
}

function limpiarDatosColegio() {
  return actions.limpiarDatosColegio();
}

function obtenerDatosPreinscripcion({ idColegio, idInscripcion }) {
  return dispatch =>
    rootRef
      .child(
        `escuelas/verano2018/preinscripciones/${idColegio}/${idInscripcion}`
      )
      .on("value", snap =>
        dispatch(
          actions.obtenerDatosPreinscripcion({
            ...snap.val(),
            resguardo: snap.key
          })
        )
      );
}

function detachDatosPreinscripcion({ idColegio, idInscripcion }) {
  return dispatch =>
    rootRef
      .child(
        `escuelas/verano2018/preinscripciones/${idColegio}/${idInscripcion}`
      )
      .off();
}

function limpiarDatosPreinscripcion() {
  return actions.limpiarDatosPreinscripcion();
}

function guardarCambiosInscripcion({ values, idColegio, idInscripcion }) {
  return dispatch => {
    let insert = {};
    insert[
      `escuelas/verano2018/preinscripciones/${idColegio}/${idInscripcion}`
    ] = values;

    rootRef.update(insert, () => {
      const payload = {
        status: true,
        message: "Se han guardado los cambios",
        resguardo: idInscripcion
      };
      dispatch(actions.dataSaved(payload));
    });
  };
}

function confirmarInscripcion({ idColegio, idInscripcion, formaDePago }) {
  const preinscripciones = "escuelas/verano2018/preinscripciones";
  const inscripciones = "escuelas/verano2018/inscripciones";
  const pre_resguardos = "escuelas/verano2018/preinscripciones_resguardos";

  return dispatch =>
    rootRef
      .child(`${preinscripciones}/${idColegio}/${idInscripcion}`)
      .once("value", snap => {
        let insert = {};
        insert[`${inscripciones}/${idColegio}/${idInscripcion}`] = {
          ...snap.val(),
          ...{
            confirmado: true,
            edad: moment().diff(moment(snap.val().nacimiento), "years"),
            formaDePago
          }
        };

        insert[`${preinscripciones}/${idColegio}/${idInscripcion}`] = null;
        insert[`${pre_resguardos}/${idColegio}/${idInscripcion}`] = null;
        rootRef.update(insert, () => {
          dispatch(
            actions.dataSaved({
              status: true,
              message: "Se ha confirmado la preinscripción",
              resguardo: idInscripcion
            })
          );
        });
      });
}

function resetSavedData() {
  return actions.resetDataSaved();
}

function columnaAlumnosSeleccionada(payload) {
  return actions.columnaAlumnosSeleccionada(payload);
}

function resetColumnaAlumnosSeleccionada() {
  return actions.resetColumnaAlumnosSeleccionada();
}

function setTipoEscuela({ idColegio, idInscripcion, tipo }) {
  const ruta = "escuelas/verano2018/preinscripciones";
  return disptach => {
    let insert = {};

    rootRef
      .child(`${ruta}/${idColegio}/${idInscripcion}/${tipo}`)
      .once("value", snap => {
        snap.val() === null || snap.val() === false
          ? (insert[`${ruta}/${idColegio}/${idInscripcion}/${tipo}`] = true)
          : (insert[`${ruta}/${idColegio}/${idInscripcion}/${tipo}`] = false);
        rootRef.update(insert, () =>
          actions.dataSaved({
            status: true,
            message: "tipoEscuela"
          })
        );
      });
  };
}

function borrarInscripcion({ idColegio, idInscripcion }) {
  const escuelas = `escuelas/verano2018/preinscripciones`;
  const idRuta = `${idColegio}/${idInscripcion}`;
  const pre_resguardos = "escuelas/verano2018/preinscripciones_resguardos";

  return dispatch =>
    rootRef.child(`${escuelas}/${idRuta}/adjuntos`).once("value", snap => {
      const adjuntos = snap.val() ? Object.values(snap.val()) : [];
      adjuntos.forEach(adjunto =>
        storageRef
          .child(`verano2018/${idColegio}/${idInscripcion}/${adjunto.fileName}`)
          .delete()
          .catch(error => console.log(error))
      );

      let insert = {};
      insert[`${escuelas}/${idRuta}`] = null;
      insert[`${pre_resguardos}/${idRuta}`] = null;

      rootRef.update(insert);
    });
}

/*---*/
export {
  obtenerPreinscripcionesPorColegio,
  limpiarPreinscripcionesPorColegio,
  obtenerPreinscripcionesDelColegio,
  detachPreinscripcionesDelColegio,
  limpiarPreinscripcionesDelColegio,
  obtenerDatosColegio,
  limpiarDatosColegio,
  obtenerDatosPreinscripcion,
  limpiarDatosPreinscripcion,
  guardarCambiosInscripcion,
  confirmarInscripcion,
  resetSavedData,
  columnaAlumnosSeleccionada,
  resetColumnaAlumnosSeleccionada,
  setTipoEscuela,
  borrarInscripcion,
  detachDatosPreinscripcion
};



// WEBPACK FOOTER //
// ./src/ducks/preinscripciones/operations.js